module.exports = __webpack_public_path__ + "img/1.e93370b4.jpg";